"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4SearchEventLabel = void 0;
var GA4SearchEventLabel;
(function (GA4SearchEventLabel) {
    GA4SearchEventLabel["SearchHistory"] = "search_history";
    GA4SearchEventLabel["SearchLastSeenProducts"] = "search_last_seen_products";
})(GA4SearchEventLabel || (exports.GA4SearchEventLabel = GA4SearchEventLabel = {}));
//# sourceMappingURL=GA4SearchEventLabel.js.map